export default {
    setClientes(state,c){
        state.clientesArray = c;
    }
}